module.exports = "/images/home.svg?1c06d2477196ca9249a10358313f5139";